export const questionTypes = {
  url: 'URL',
  task: 'Text',
  range: 'Rating Scale',
  written: 'Written Response',
  multiple_select: 'Multiple Selection (pick any)',
  single_select: 'Single Selection (pick one)',
  image_select: 'Image',
  audio_video: 'Video or Audio',
  ranking: 'Ranking',
  five_second: 'Five Second Test',
  matrix: 'Matrix',
  first_click_test: 'First Click Test',
  preference: 'Preference Test',
};
